import { useRef, useEffect } from "react";

/**
 * Get previous value
 * Similiar to method in componentDidUpdate
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>(); // store current value as ref

  useEffect(() => {
    ref.current = value;
  }, [value]); // rerun if value changes

  return ref.current; // return previous value
}
